import { render, staticRenderFns } from "./RemMsgContainer.vue?vue&type=template&id=0efc31f3&scoped=true&"
import script from "./RemMsgContainer.vue?vue&type=script&lang=js&"
export * from "./RemMsgContainer.vue?vue&type=script&lang=js&"
import style0 from "./RemMsgContainer.vue?vue&type=style&index=0&id=0efc31f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efc31f3",
  null
  
)

export default component.exports